// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__jmXtJ","icons":"Footer_icons__vFgv7","iconBlock":"Footer_iconBlock__Z3IMt"};